function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/tooltip/tooltipview
 */
import View from '../view';
import '../../theme/components/tooltip/tooltip.css';
/**
 * The tooltip view class.
 *
 * @extends module:ui/view~View
 */

var TooltipView = /*#__PURE__*/function (_View) {
  _inherits(TooltipView, _View);

  var _super = _createSuper(TooltipView);

  /**
   * @inheritDoc
   */
  function TooltipView(locale) {
    var _this;

    _classCallCheck(this, TooltipView);

    _this = _super.call(this, locale);
    /**
     * The text of the tooltip visible to the user.
     *
     * @observable
     * @member {String} #text
     */

    _this.set('text', '');
    /**
     * The position of the tooltip (south, south-west, south-east, or north).
     *
     *		+-----------+
     *		|   north   |
     *		+-----------+
     *		      V
     *		  [element]
     *
     *		  [element]
     *		      ^
     *		+-----------+
     *		|   south   |
     *		+-----------+
     *
     *                +----------+
     *    [element] < |   east   |
     *                +----------+
     *
     *    +----------+
     *    |   west   | > [element]
     *    +----------+
     *
     *		         [element]
     *		             ^
     *		+--------------+
     *		|  south west  |
     *		+--------------+
     *
     *	  [element]
     *		  ^
     *		+--------------+
     *		|  south east  |
     *		+--------------+
    	 * @observable
     * @default 's'
     * @member {'s'|'n'|'e'|'w'|'sw'|'se'} #position
     */


    _this.set('position', 's');

    var bind = _this.bindTemplate;

    _this.setTemplate({
      tag: 'span',
      attributes: {
        class: ['ck', 'ck-tooltip', bind.to('position', function (position) {
          return 'ck-tooltip_' + position;
        }), bind.if('text', 'ck-hidden', function (value) {
          return !value.trim();
        })]
      },
      children: [{
        tag: 'span',
        attributes: {
          class: ['ck', 'ck-tooltip__text']
        },
        children: [{
          text: bind.to('text')
        }]
      }]
    });

    return _this;
  }

  return TooltipView;
}(View);

export { TooltipView as default };